// Pure query serialisation for the Google watchlist (contract 27 §9 `service/creative/`).
// Framework-free: no Vue, no store, no `shared/http`.
import type { WatchlistFilter, WatchlistQuery } from '../../models/creativeWatchlist.types'

/**
 * v3 `GoogleCreativesView.vue:341–364` (`buildQueryParams`) plus the `page` the two call sites
 * appended by hand afterwards (`:421`, `:478`). Ordering follows v3 so a captured URL still
 * matches: `page_size`, `search`, `ordering`, `filters`, `page`.
 *
 * Empty `search`/`ordering`/`filters` are OMITTED, not sent blank — v3 parity, and it keeps the
 * request cache key stable across a cleared search box.
 */
export function serializeWatchlistQuery(query: WatchlistQuery): string {
  const params = new URLSearchParams()
  params.append('page_size', String(query.page_size))

  if (query.search) params.append('search', query.search)
  if (query.ordering) params.append('ordering', query.ordering)

  const filters = usableFilters(query.filters)
  if (filters.length > 0) params.append('filters', JSON.stringify(filters))

  params.append('page', String(query.page))
  return params.toString()
}

/** v3 `:355–358`: incomplete clauses are dropped and `match_mode` goes out UPPER-CASED. */
function usableFilters(filters: WatchlistFilter[] | undefined): WatchlistFilter[] {
  return (filters ?? [])
    .filter((filter) => Boolean(filter?.field) && Boolean(filter?.match_mode))
    .map((filter) => ({
      field: filter.field,
      match_mode: filter.match_mode.toUpperCase(),
      value: filter.value,
    }))
}
